export function resetProxy<T extends object>(proxy: T, initialState: T): void {
  // Delete all existing keys in store
  for (const key of Object.keys(proxy)) {
    delete proxy[key as keyof T];
  }
  // Assign initial state to store
  Object.assign(proxy, initialState);
}
